"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _Breadcrumb = _interopRequireDefault(require("@/components/Breadcrumb"));
var _Hamburger = _interopRequireDefault(require("@/components/Hamburger"));
var _user = require("../../api/user");
var _auth = require("@/utils/auth");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Breadcrumb: _Breadcrumb.default,
    Hamburger: _Hamburger.default
  },
  data: function data() {
    var _this = this;
    var oldPassword = function oldPassword(rule, value, callback) {
      if (!value) {
        return callback(new Error('密码不能为空！'));
      }
      var regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,20}$/;
      if (!regex.test(value)) {
        return callback(new Error('密码格式不正确'));
      } else {
        callback();
      }
    };
    var oldPassword1 = function oldPassword1(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== _this.formData.newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      appStatus: sessionStorage.getItem('appStatus'),
      passwordType: true,
      passwordType1: true,
      passwordType2: true,
      showBoole: false,
      formData: {
        rawPwd: '',
        // 原密码
        newPwd: '',
        // 新密码
        newPwd1: '' // 新密码
      },
      rules: {
        psd: [{
          required: true,
          message: '请填写密码',
          trigger: 'blur'
        }],
        rawPwd: [
          // { validator: oldPassword, trigger: 'blur' }
        ],
        newPwd: [{
          validator: oldPassword,
          trigger: 'blur'
        }],
        newPwd1: [{
          validator: oldPassword1,
          trigger: 'blur'
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['sidebar', 'avatar', 'name', 'id', 'breadList', 'breadActiveNum'])), {}, {
    editableTabsValue: {
      get: function get() {
        return this.breadActiveNum;
      },
      set: function set(val) {
        this.$store.commit('user/SET_NUM', val);
      }
    }
  }),
  methods: {
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          // alert('submit!')
          _this2.$confirm('是否确认确认修改密码?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            console.log('11111111');
            _this2.onPasswordChange();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    removeTab: function removeTab(targetName) {
      // console.log(this.$store.getters.breadList, this.$store.getters.breadActiveNum)
      if (targetName !== this.editableTabsValue) {
        console.log(this.$route, this.$store);
        if (targetName < this.editableTabsValue) {
          this.editableTabsValue -= 1;
        }
        this.breadList.splice(targetName, 1);
      } else {
        if (!(this.breadList.length === 1 && this.editableTabsValue * 1 === 0)) {
          if (this.editableTabsValue * 1 !== 0) {
            this.editableTabsValue -= 1;
          }
          this.breadList.splice(targetName, 1);
          this.$router.push({
            path: this.breadList[this.editableTabsValue].path
          });
          if (this.breadList[this.editableTabsValue].isMore) {// 同一个页面跳转刷新页面
            // this.$router.go(0)
          }
        }
      }
    },
    bothJump: function bothJump(val) {
      console.log(this.breadList[val.name].isMore, '---------------------');
      this.$router.push({
        path: this.breadList[val.name].path
      });
      if (this.breadList[val.name].isMore) {// 同一个页面跳转刷新页面
        // this.$router.go(0)
      }
    },
    getOpen: function getOpen() {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.$refs.form1.clearValidate();
      });
    },
    close: function close() {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.$refs.form1.resetFields(); // 只清除清除验证
      });
      this.showBoole = false;
    },
    resetForm: function resetForm() {
      this.$refs.form1.resetFields();
      this.showBoole = false;
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function () {
      var _logout = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.$store.dispatch('user/logout');
            case 1:
              this.$router.push("/login");
              // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }(),
    onPasswordChange: function () {
      var _onPasswordChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({
                username: this.name
              }, this.formData);
              delete params.newPwd1;
              _context2.n = 1;
              return (0, _user.passwordChange)(params);
            case 1:
              res = _context2.v;
              console.log('res', res);
              if (res.data) {
                (0, _auth.removeToken)();
                this.$store.dispatch('user/resetToken').then(function () {
                  location.reload();
                });
                // this.$router.push(`/login`)
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              console.log(_t);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function onPasswordChange() {
        return _onPasswordChange.apply(this, arguments);
      }
      return onPasswordChange;
    }()
  }
};